<template>
  <b-row>
    <b-col cols="12">
      <hr class="my-1">
      <span class="h6 float-left">{{$t("views.agreements.form.items")}}: </span>
    </b-col>
    <b-col v-if="!isMassEdit">
      <b-form-group>
        <label for="payment_frequency">
          {{ $t('views.agreements.form.paymentPeriod') }}:
        </label>
        <model-select
          @input="$forceUpdate()"
          id="payment_frequency"
          v-model="data.paymentFrequency"
          :options="paymentFrequencyOptions">
        </model-select>
      </b-form-group>
    </b-col>
    <b-col v-if="!isMassEdit" sm="12" md="6">
      <b-form-group>
        <label for="day_next_payments">
          {{ $t('views.agreements.form.dayNextPayments') }}:
        </label>
        <model-select
          id="day_next_payments"
          v-model="data.dayNextPayments"
          :options="monthDays">
        </model-select>
      </b-form-group>
    </b-col>
    <b-col v-if="!isMassEdit" cols="12">
      <b-form-group>
        <label>{{$t("views.agreements.form.package")}}: </label>
        <model-select
          :isDisabled="getBoolean(data['@id'])"
          class="invalid-feedback"
          name="package"
          :options="packageOptions"
          v-model="data.package">
        </model-select>
        <div v-if="isInvalid('package')" class="text-danger">
          {{ violations.package }}
        </div>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <table v-if="data.agreementItems && data.agreementItems.length > 0" class="table table-responsive-md table-sm table-hover not-border-table">
        <thead class="text-center">
        <tr>
          <th style="width: 4%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.lp')}}</p>
          </th>
          <th style="width: 3%">
            <i class="fa fa-gifts fa-lg" v-b-tooltip :title="$t('buttons.addItemsToVariant')"></i>
          </th>
          <th style="width: 3%">
            <i class="fa fa-clock fa-lg" v-b-tooltip :title="$t('buttons.cyclicItem')"></i>
          </th>
          <th  style="width: 3%">
            <i class="fa fa-ballot-check fa-lg" v-b-tooltip :title="$t('views.exsbinvoices.form.invoicePositionHeaders.hasPriceGroup')"></i>
          </th>
          <th style="width: 3%">
            <i class="fa fa-percentage fa-lg" v-b-tooltip :title="$t('buttons.promotion')"></i>
          </th>
          <th style="width: 19%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.item')}}</p>
          </th>
          <th style="width: 19%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueNetto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatRate')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.vatAmount')}}</p>
          </th>
          <th style="width: 19%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.valueBrutto')}}</p>
          </th>
          <th style="width: 10%">
            <p>{{$t('views.exsbinvoices.form.invoicePositionHeaders.promotionDifference')}}</p>
          </th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody v-for="(item, index) in data.agreementItems" :key="index">
        <tr v-if="items && items.length > 0">
          <td><span class="h6"> {{ index + 1 }} </span></td>
          <!--    TOWAR-->
          <td>
            <b-form-checkbox
              :id="`selectedcheckbox-${index}`"
              v-model="selectedItems"
              :name="`selectedcheckbox-${index}`"
              :value="item"
            >
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox
              :id="`checkbox-${index}`"
              v-model="item.isCyclic"
              :name="`checkbox-${index}`"
              :value="1"
              :unchecked-value="0"
              :disabled="!item.canBeCyclic || !item.item"
            >
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox
              :id="`checkboxpricegroup-${index}`"
              v-model="item.hasPriceGroup"
              :name="`checkboxpricegroup-${index}`"
              :value="true"
              :unchecked-value="false"
            >
            </b-form-checkbox>
          </td>
          <td>
            <b-form-checkbox
              :id="`checkboxpromotion-${index}`"
              v-model="item.hasPromotion"
              :name="`checkboxpromotion-${index}`"
              :value="true"
              :unchecked-value="false"
              :disabled="hasItemCustomPrices(index)"
            >
            </b-form-checkbox>
          </td>
          <td>
            <model-select v-if="data.agreementItems.length > 0 && data.agreementItems[index].hasPriceGroup === false"
                          v-model="data.agreementItems[index].item"
                          :options="itemOptions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="item">
            </model-select>
            <model-select v-if="data.agreementItems.length > 0 && data.agreementItems[index].hasPriceGroup === true"
                          v-model="data.agreementItems[index].priceGroup"
                          :options="priceGroups"
                          :placeholder="$t('views.agreements.form.select')"
                          name="item">
            </model-select>
          </td>
          <!--    WARTOŚĆ NETTO-->
          <td class="pt-0 pb-0">
            <input type="number" disabled="true" :value="getPriceNetto(index)" class="form-control">
          </td>
          <!--    STAWKA VAT-->
          <td>
            <input type="text" disabled="true" :value="getVatRate(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ VAT-->
          <td>
            <input type="number" disabled="true" :value="getVatValue(index)" class="form-control">
          </td>
          <!--    WARTOŚĆ BRUTTO-->
          <td v-if="hasItemCustomPrices(index)">
            <model-select :options="priceOptions[index]" v-model="data.agreementItems[index].priceUserData"></model-select>
          </td>
          <td v-else>
            <input type="number" disabled="true" :value="getPriceBrutto(index)" class="form-control">
          </td>
          <td>
            <input v-if="item.item" type="number" disabled="true" :value="(getPriceBrutto(index) - getItemById(getCurrentItem(index).item).priceBrutto).toFixed(2)" class="form-control">
          </td>
          <td>
              <button
                type="button"
                class="btn btn-link fa fa-trash fa-lg"
                @click="removePosition(index)"
                v-b-tooltip :title="$t('buttons.delete')">
              </button>
          </td>
        </tr>
        <tr v-if="item.isCyclic">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.cyclicItem')}}</b>
          </td>
          <td colspan="5">
            <b-row>
              <b-col cols="1" align-self="center">
                <span class="mr-3">
                  <b>{{$t('global.from')}}:</b>
                </span>
              </b-col>
              <b-col>
                <b-form-group>
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    placement="bottom-start"
                    class="d-inline-block"
                    id="date_from"
                    v-model="data.agreementItems[index].dateFrom"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col v-if="!item.timeless" cols="1" align-self="center">
                <span class="mr-3">
                  <b>{{$t('global.to')}}:</b>
                </span>
              </b-col>
              <b-col v-if="!item.timeless">
                <b-form-group>
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    placement="bottom-start"
                    class="d-inline-block"
                    id="date_to"
                    v-model="data.agreementItems[index].dateTo"
                    type="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd">
                  </el-date-picker>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                    v-model="data.agreementItems[index].timeless"
                    :name="`timeless_${index}`"
                    :value="true"
                    :unchecked-value="false"
                    @input="setTimelessItem(index)">
                  <span>
                    {{$t('views.agreements.form.timelessCyclicItem')}}
                  </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-form-group>
                  <b-form-checkbox
                    v-model="data.agreementItems[index].alwaysSettleInFull"
                    :name="`alwaysSettleInFull_${index}`"
                    :value="1"
                    :unchecked-value="0">
                  <span>
                    {{$t('views.agreements.form.alwaysSettleInFull')}}
                  </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </td>
        </tr>
        <tr v-if="item.hasPromotion">
          <td colspan="3"></td>
          <td>
            <b>{{$t('buttons.promotion')}}</b>
          </td>
          <td>
            <b v-if="item.item">{{$t('views.agreements.form.basePriceWithoutPromotion')}}: {{ getItemById(getCurrentItem(index).item).priceBrutto }}</b>
          </td>
          <td colspan="4">
            <model-select v-if="getPromotions.length > 0"
                          v-model="data.agreementItems[index].promotion"
                          :options="getPromotions"
                          :placeholder="$t('views.agreements.form.select')"
                          name="promotion">
            </model-select>
          </td>
        </tr>
        </tbody>
      </table>
      <b-row>
        <b-col>
          <b-button class="btn float-left btn-primary" @click="addNewPosition()">{{ $t('views.exsbinvoices.form.addNewInvoicePosition') }}</b-button>
          <b-button class="btn float-left btn-primary" @click="addNewEmptyVariant()">{{ $t('buttons.addVariant') }}</b-button>
          <b-button class="btn float-left btn-primary" :disabled="selectedItems.length === 0" @click="addNewVariant()">{{ $t('buttons.addItemsToVariant') }}</b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12" v-for="(variant, variantIndex) in data.agreementVariants" :key="variantIndex">
      <hr>
      <b-row>
        <div class="text-center d-inline-block align-self-center ml-3">
          <button
            type="button"
            class="btn btn-link fa fa-trash fa-lg"
            @click="removeVariant(variantIndex)"
            v-b-tooltip :title="$t('buttons.delete')">
          </button>
        </div>
        <b-col class="border-left">
          <AgreementVariants :variant="variant" :variant-index="variantIndex" :data="data" :items="items"
                             :get-promotions="getPromotions" :item-options="itemOptions" :price-options="priceOptions"/>
        </b-col>
      </b-row>
    </b-col>
    <b-col><hr></b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import addParamsToQuery from '@/utils/addParamsToQuery'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import remove from '@/utils/remove'
import AgreementVariants from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementVariants'

export default {
  name: 'AgreementItems',
  data () {
    return {
      priceUserDataObjects: [],
      priceOptions: [],
      isLoading: false,
      selectedItems: []
    }
  },

  props: ['data', 'violations', 'isInvalid', 'itemsFromAgreement', 'createAgreementItemsMulti'],

  components: {
    AgreementVariants,
    ModelSelect
  },

  computed: {
    isMassEdit () {
      return !!this.itemsFromAgreement || this.createAgreementItemsMulti
    },
    monthDays () {
      let daysOfMonth = []
      for (let dayOfMonth = 1; dayOfMonth <= 31; dayOfMonth++) {
        daysOfMonth.push({ value: dayOfMonth, text: dayOfMonth })
      }
      return daysOfMonth
    },
    itemOptions () {
      if (this.itemsFromAgreement) {
        return this.itemsFromAgreement.map(entry => {
          return {
            value: entry['@id'],
            text: entry.name
          }
        })
      }
      if (!this.items) return []
      else {
        return this.items.map(entry => {
          return {
            value: entry['@id'],
            text: entry.name
          }
        })
      }
    },
    ...mapGetters({
      items: 'exsbitem/list/items',
      priceGroups: 'exsbitem/list/priceGroupOptions',
      paymentFrequency: 'agreements/list/paymentFrequency',
      getPackages: 'packages/list/getPackages',
      getPromotions: 'agreements/list/getPromotions'
    }),
    isUpdateRoute () {
      return this.$route.name === 'EXABAgreementsUpdate'
    },
    paymentFrequencyOptions () {
      return Object.keys(this.paymentFrequency).map(entry => {
        return {
          value: parseInt(entry),
          text: this.$t(this.paymentFrequency[entry])
        }
      })
    },
    packageOptions () {
      let packages = this.getPackages.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
      packages.unshift({
        text: this.$t('global.notSet'),
        value: null
      })
      return packages
    }
  },

  watch: {
    'data.package': function (link) {
      this.fillAgreementFromPackage(link)
    },
    'data.timelessAgreement': {
      immediate: true,
      handler (val) {
        this.data.agreementItems.forEach(entry => {
          if (val && !entry.dateTo) entry.timeless = true
        })
      }
    },
    'data.dateFrom': {
      handler (val) {
        this.data.agreementItems.forEach(entry => {
          if (entry.isCyclic) {
            entry.dateFrom = val
          }
        })
      }
    },
    'data.dateTo': {
      handler (val) {
        this.data.agreementItems.forEach(entry => {
          if (entry.isCyclic) {
            entry.dateTo = val
          }
        })
      }
    },
    'data.idClient': {
      handler (val) {
        if (val) {
          if (!this.isUpdateRoute) this.data.agreementItems = []
          this.fetchPriceUserData()
        }
      }
    },
    // watch for new items
    'data.agreementItems': {
      deep: true,
      handler (val) {
        this.setIsCyclicItem(val)
        this.handlePriceOptions(val)
        this.handlePromotions(val)
      }
    },
    items (val) {
      if (!this.isLoading && this.isUpdateRoute && val.length > 0) {
        this.handlePriceOptions(this.data.agreementItems)
      }
    }
  },

  created () {
    this.getPackageOptions()
    this.getItems()
    this.getPriceGroups()
  },

  methods: {
    getBoolean (val) {
      return Boolean(val)
    },
    getItemById (id) {
      return this.items.find(item => item['@id'] === id)
    },
    setTimelessItem (index) {
      if (this.getCurrentItem(index).timeless) this.getCurrentItem(index).dateTo = null
    },
    setIsCyclicItem (val) {
      if (!val) return
      val.forEach((item, index) => {
        if (item.item) this.data.agreementItems[index].canBeCyclic = Boolean(this.getItemById(item.item).isCyclic)
        if (!this.data.agreementItems[index].canBeCyclic && this.data.agreementItems[index].hasPriceGroup === false) {
          this.data.agreementItems[index].isCyclic = 0
        }
        if (this.data.agreementItems[index].hasPriceGroup === true) {
          this.data.agreementItems[index].isCyclic = 1
          this.data.agreementItems[index].item = null
        } else {
          this.data.agreementItems[index].priceGroup = null
        }
      })
    },
    handlePriceOptions (val) {
      if (!val) return
      val.forEach((item, index) => {
        // filter priceOptions for every item in agreement
        let options = this.priceUserDataObjects.filter(entry => {
          return entry.idItem['@id'] === item.item
        })
        this.setPriceOptionsForItem(options, index)
      })
    },
    handlePromotions (val) {
      if (!val) return
      val.forEach((item) => {
        if (!item.hasPromotion) {
          item.promotion = null
        }
        if (item.promotion) {
          item.hasPromotion = true
        }
      })
    },
    ...mapActions({
      fetchPackageOptions: 'packages/list/fetchPackages',
      fetchItems: 'exsbitem/list/getItems',
      fetchPriceGroups: 'exsbitem/list/getPriceGroups'
    }),
    getItems () {
      if (this.itemsFromAgreement) {
        return
      }
      let link = addParamsToQuery('e_x_s_b_items', {
        pagination: false
      })
      this.fetchItems(link)
    },
    getPackageOptions () {
      if (this.itemsFromAgreement) {
        return
      }
      let link = addParamsToQuery('e_x_a_b_packages', {
        pagination: false
      })
      this.fetchPackageOptions(link)
    },
    getPriceGroups () {
      let link = addParamsToQuery('e_x_s_b_price_groups', {
        pagination: false
      })
      this.fetchPriceGroups(link)
    },
    setPriceOptionsForItem (options, index) {
      if (!this.getCurrentItem(index).item) return
      this.priceOptions[index] = options.map(entry => {
        return {
          value: entry['@id'],
          text: this.$t('views.exsbpriceuserdata.list.customPrice') + ' - ' + entry.priceBrutto
        }
      })
      this.priceOptions[index].push({
        value: null,
        text: this.$t('views.exsbpriceuserdata.list.basePrice') + ' - ' + this.getItemById(this.getCurrentItem(index).item).priceBrutto
      })
    },
    hasItemCustomPrices (index) {
      if (!this.priceOptions[index]) return false
      return this.priceOptions[index].length > 1
    },
    removePosition (index) {
      let currentItem = this.data.agreementItems[index]
      if (currentItem['@id']) {
        remove(currentItem['@id'], () => {
          this.data.agreementItems.splice(index, 1)
          this.data.originalAgreementItems = JSON.stringify(this.data.agreementItems)
        })
      } else {
        this.data.agreementItems.splice(index, 1)
      }
    },
    addNewPosition () {
      this.data.agreementItems.push({
        item: '',
        priceUserData: null,
        isCyclic: 0,
        alwaysSettleInFull: 0,
        dateFrom: this.data.dateFrom,
        dateTo: this.data.dateTo,
        timeless: Boolean(this.data.timelessAgreement),
        hasPromotion: false,
        promotion: null,
        hasPriceGroup: false,
        priceGroup: null
      })
    },
    addNewEmptyVariant () {
      let newVariant = {
        title: '',
        variantItems: [],
        variantAdditionalItems: []
      }
      this.data.agreementVariants.push(newVariant)
    },
    addNewVariant () {
      if (this.selectedItems.length === 0) {
        return
      }
      let newVariant = {
        title: '',
        variantItems: [],
        variantAdditionalItems: []
      }
      this.selectedItems.forEach((item) => {
        let variantItem = JSON.parse(JSON.stringify(item))
        delete variantItem['@id'] // Nie chcemy tutaj id usługi w umowie, po stronie back-endu zapisze się tutaj id wariantu
        newVariant.variantItems.push(variantItem)
      })
      this.data.agreementVariants.push(newVariant)
      this.selectedItems = []
    },
    removeVariant (index) {
      let currentItem = this.data.agreementVariants[index]
      if (currentItem['@id']) {
        remove(currentItem['@id'], () => {
          this.data.agreementVariants.splice(index, 1)
        })
      } else {
        this.data.agreementVariants.splice(index, 1)
      }
    },
    getPriceNetto (index) {
      return Math.round((this.getPriceBrutto(index) - this.getVatValue(index)) * 100) / 100
    },
    getPriceBrutto (index) {
      if (!this.getCurrentItem(index).item || this.items.length < 1) return 0
      let isCustomPriceSelected = (this.getCurrentItem(index).priceUserData && typeof this.getCurrentItem(index).priceUserData === 'string')
      if (isCustomPriceSelected) {
        return this.priceUserDataObjects.find(entry => {
          return entry.idItem['@id'] === this.getCurrentItem(index).item
        }).priceBrutto
      }
      let promotionId = (this.getCurrentItem(index).promotion)
      if (promotionId && this.getPromotions.length > 1) {
        let promotion = this.getPromotions.find(promotion => promotion.value === promotionId)
        let basePriceBrutto = this.getItemById(this.getCurrentItem(index).item).priceBrutto
        if (promotion.type === 0) { // Promocja kwotowa
          return (basePriceBrutto - promotion.promotionValue).toFixed(2)
        } else if (promotion.type === 1) { // Promocja procentowa
          return (basePriceBrutto - (promotion.promotionValue / 100) * basePriceBrutto).toFixed(2)
        }
      }
      return this.getItemById(this.getCurrentItem(index).item).priceBrutto
    },
    getVatRate (index) {
      if (!this.getCurrentItem(index).item || this.items.length < 1) return 0
      return this.getItemById(this.getCurrentItem(index).item).vatRate.value
    },
    getVatValue (index) {
      if (!this.getCurrentItem(index).item) return 0
      return Math.round(this.calculateVatValue(index) * 100) / 100
    },
    calculateVatValue (index) {
      return (this.getPriceBrutto(index) * this.getVatRate(index)) / (100 + this.getVatRate(index))
    },
    getCurrentItem (index) {
      if (!this.data.agreementItems[index]) return null
      return this.data.agreementItems[index]
    },
    async fetchPriceUserData () {
      this.isLoading = true
      let url = addParamsToQuery('e_x_s_b_price_user_datas', { idUserData: getId(this.data.idClient) })
      let params = { pagination: false }
      const response = await new ApiService(url, params).getResults()
      this.priceUserDataObjects = response.items
      this.isLoading = false
    },
    async fillAgreementFromPackage (link) {
      this.data.agreementItems = []
      this.data.agreementPromotions = []
      this.data.agreementDevices = []
      if (!link) {
        return
      }
      const packageItem = await new ApiService(link).getResults()
      for (let i in packageItem.packageItems) {
        this.data.agreementItems.push({
          item: packageItem.packageItems[i].item,
          priceUserData: null,
          isCyclic: 0,
          alwaysSettleInFull: 0,
          dateFrom: this.data.dateFrom,
          dateTo: this.data.dateTo,
          timeless: Boolean(this.data.timelessAgreement),
          hasPriceGroup: 0,
          priceGroup: null
        })
      }
      for (let j in packageItem.packagePromotions) {
        this.data.agreementPromotions.push({ promotion: packageItem.packagePromotions[j].promotion })
      }
      for (let k in packageItem.packageDevices) {
        this.data.agreementDevices.push({ device: packageItem.packageDevices[k].device })
      }
    }
  }
}
</script>
